import { BaseDto } from "@/shared/dtos/base-dto";

export class DashboardDoughnutDto extends BaseDto {

  public objetivos_smart!: [];
  public actuaciones_ambitos_smart!: [];
  public actuaciones_tipos_smart!: [];
}